<template>
  <div class="occasion-teaser-item" @click="goToOccasion">
    <div class="inner">
      <div class="row">
        <div class="col-md-4 teaser-image">
          <img :src="image" :alt="item.field_title">
        </div>
        <div class="col-md-8">
          <h2 class="virtual-p font-weight-bold">
            <a :href="item.field_url" class="text-decoration-none">
              {{ item.field_brand_and_model }}

              <template v-if="item.field_title">
                | {{ item.field_title }}
              </template>
            </a>
          </h2>

          <div class="intro-information">
            <div class="price info-item mr-4">{{ item.field_price | toCurrency }}</div>

            <template v-if="item.field_construction_year">
              <div class="info-item mr-4">
                <span class="visually-hidden">Bouwjaar: </span>
                <svg class="icon">
                  <use xlink:href="#icon-key"></use>
                </svg>
                {{ item.field_construction_year }}
              </div>
            </template>

            <template v-if="item.field_mileage">
              <div class="info-item mr-4">
                <svg class="icon">
                  <use xlink:href="#icon-dashboard"></use>
                </svg>
                {{ item.field_mileage }} km
              </div>
            </template>
          </div>

          <hr class="my-3 mt-md-6 mb-md-3">

          <template v-if="hasGarage === true">
            <div class="garage">
              <div class="inner">
                <h3 class="name virtual-p font-weight-bold mb-1">
                  {{ item.field_garage.name }}
                </h3>

                <div class="d-md-flex">
                  <div class="tel mr-4" v-if="item.field_garage.tel">
                    <span class="visually-hidden">Tel: </span><a :href="`tel:${phoneNumber.number}`">{{
                      item.field_garage.tel
                    }}</a>
                  </div>

                  <div class="email mr-4" v-if="item.field_garage.email">
                    <span class="visually-hidden">Email: </span><a :href="`mailto:${item.field_garage.email}`">{{
                      item.field_garage.email
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';

export default {
  name: "OccasionListItem",

  props: ['item'],

  filters: {
    toCurrency(value) {
      value = parseInt(value);

      if (typeof value !== "number") {
        return value;
      }

      let formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });

      return formatter.format(value);
    }
  },

  computed: {
    hasGarage() {
      return !_.isEmpty(this.item.field_garage);
    },

    phoneNumber() {
      if (!this.hasGarage) {
        return;
      }

      if (_.isNil(this.item.field_garage.tel)) {
        return;
      }

      return parsePhoneNumber(this.item.field_garage.tel, 'NL');
    },

    image() {
      if (_.isEmpty(this.item.field_image)) {
        return '/themes/custom/ef2_custom/img/occasion-placeholder.jpg';
      }

      return this.item.field_image;
    }
  },

  methods: {
    goToOccasion() {
      window.location = this.item.field_url;
    }
  }
}
</script>
